import React, { useState, useEffect, useRef } from 'react';
import {useNavigate} from "react-router-dom";
import { Select, MenuItem, FormControl, InputLabel, RadioGroup, FormControlLabel, TextField, Radio } from '@mui/material';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import { DrugExceptionResponse, AssessorResponse, DrugExceptionStatus, AccessType, RelationshipType } from '../../../model/Reformulary';
import './approve.css';
import FormatDateLocale from '../../../util/DateUtil';

interface HandleError {
    handleError: Function;
}
export default function AdminApprove(props: HandleError) {
    const userId = JSON.parse(sessionStorage.getItem('userId') || '');
    const selectedDrugException: DrugExceptionResponse = JSON.parse(sessionStorage.getItem('selectedDrugException') || '');
    const drugExceptionsClient = new DrugExceptionsClient();
    const history = useNavigate();
    const [status, setStatus] = useState<string>(DrugExceptionStatus[DrugExceptionStatus.UNDER_REVIEW]);
    console.log(`status:  ${status}`)
    const [comment, setComment] = useState<string>(selectedDrugException.comment);
    const [assessors, setAssessors] = useState<AssessorResponse[]>([]);
    const [assessorId, setAssessorId] = useState<string>(String(selectedDrugException.assessorId) || '');
    const [loading, setLoading] = useState<boolean>(true);
    const [documents, setDocuments] = useState<{ file: Blob; url: string }[]>([]);
    const [accountHolder, updateAccountHolder] = useState<{ firstName: string; lastName: string }>({ firstName: '', lastName: '' });

    const [medicalCondition, updateMedicalCondition] = useState(selectedDrugException.medicalCondition);
    const [DIN, updateDIN] = useState(selectedDrugException.din);
    const [drugName, updateDrugName] = useState(selectedDrugException.drugName);
    const [effectiveDateDay, updateEffectiveDateDay] = useState(selectedDrugException.effectiveDate ? String(new Date(selectedDrugException.effectiveDate).getDate()) : '');
    const [effectiveDateMonth, updateEffectiveDateMonth] = useState(selectedDrugException.effectiveDate ? String(new Date(selectedDrugException.effectiveDate).getMonth()): '');
    const [effectiveDateYear, updateEffectiveDateYear] = useState(selectedDrugException.effectiveDate ? String(new Date(selectedDrugException.effectiveDate).getFullYear()): '');
    const [terminationDateDay, updateTerminationDateDay] = useState(selectedDrugException.terminationDate ? String(new Date(selectedDrugException.terminationDate).getDate()): '');
    const [terminationDateMonth, updateTerminationDateMonth] = useState(selectedDrugException.terminationDate ? String(new Date(selectedDrugException.terminationDate).getMonth()): '');
    const [terminationDateYear, updateTerminationDateYear] = useState(selectedDrugException.terminationDate ? String(new Date(selectedDrugException.terminationDate).getFullYear()): '');
    const [reimbursementTierApproved, updateReimbursementTierApproved] = useState(selectedDrugException.reimbursementTierApproved);
    const [physicianName, updatePhysicianName] = useState(selectedDrugException.physicianName);
    const [physicianLicense, updatePhysicianLicense] = useState(selectedDrugException.physicianLicense);
    const [physicianFSA, updatePhysicianFSA] = useState(selectedDrugException.physicianFSA);
    const [adminNotes, updateAdminNotes] = useState(selectedDrugException.adminNotes);

    const [updatedMessage, updateUpdatedMessage] = useState('');

    const assigned = selectedDrugException.assessorId !== 0;
    const rejected = selectedDrugException.drugExceptionStatus === DrugExceptionStatus[DrugExceptionStatus.NOT_APPROVED];
    const isDependant = (selectedDrugException.claimant?.relationshipType || '') === RelationshipType[RelationshipType.DEPENDANT];
    const underReview = selectedDrugException.drugExceptionStatus === DrugExceptionStatus[DrugExceptionStatus.UNDER_REVIEW];
    const assessed = selectedDrugException.drugExceptionStatus === DrugExceptionStatus[DrugExceptionStatus.ASSESSED_APPROVED] || selectedDrugException.drugExceptionStatus === DrugExceptionStatus[DrugExceptionStatus.ASSESSED_NOT_APPROVED];
    const completed = selectedDrugException.drugExceptionStatus === DrugExceptionStatus[DrugExceptionStatus.APPROVED] || selectedDrugException.drugExceptionStatus === DrugExceptionStatus[DrugExceptionStatus.NOT_APPROVED];


    async function fetchData() {
        setLoading(true);
        let assessorResponse;
        if (userId) {
            const token = userId.authToken;
            const id = userId.id;
            if (token && id) {

                const accountHolderGetURL = selectedDrugException.claimant?.addedByUser.accessType === AccessType[AccessType.ADMIN_ACCESS]
                    ? `/administrators/user/${selectedDrugException.claimant?.addedByUser.id}`
                    : `/claimants/user/${selectedDrugException.claimant?.addedByUser.id}`;

                const accountHolderResponse = await drugExceptionsClient.api.get(accountHolderGetURL, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                updateAccountHolder(accountHolderResponse?.data);

                assessorResponse = await drugExceptionsClient.api.get('/assessors', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setAssessors(assessorResponse?.data);

                const documentIdResponse = await drugExceptionsClient.api.get(`/drugexceptions/${selectedDrugException.id}/documents`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                });

                const documentIds: string[] = documentIdResponse.data;

                documentIds.map(async id => {
                    const documentResponse = await drugExceptionsClient.api.get(`/drugexceptions/${selectedDrugException.id}/document/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                        responseType: 'blob'
                    });

                    setDocuments(oldDocuments => [...oldDocuments, { file: documentResponse.data, url: URL.createObjectURL(documentResponse.data) }]);

                });
            }
        }
        setLoading(false);
    }

    const handleStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStatus((event.target as HTMLInputElement).value);
    };

    const handleMedicalConditionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateMedicalCondition((event.target as HTMLInputElement).value);
    };

    const handleDINChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value.length > 8) return;
        updateDIN((event.target as HTMLInputElement).value);
    };

    const handleDrugNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateDrugName((event.target as HTMLInputElement).value);
    };

    const handleEffectiveDateDayChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateEffectiveDateDay((event.target as HTMLInputElement).value);
    };

    const handleEffectiveDateMonthChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateEffectiveDateMonth((event.target as HTMLInputElement).value);
    };

    const handleEffectiveDateYearChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateEffectiveDateYear((event.target as HTMLInputElement).value);
    };

    const handleEffectiveDateError = (field: string) => {
        if (effectiveDateDay === '' && effectiveDateMonth === '' && effectiveDateYear === '') {
            return false;
        }
        switch (field) {
            case 'day':
                if (Number(effectiveDateDay) > 31 || Number(effectiveDateDay) < 1) {
                    return true;
                } 
                break;
            case 'month':
                if (effectiveDateMonth === '') {
                    return true;
                } 
                break;
            case 'year':
                if (Number(effectiveDateYear) < 1900 || Number(effectiveDateYear) > 3000) {
                    return true;
                } 
                break;
            default:
                return false;
                break;
        }
    };

    const handleTerminationDateError = (field: string) => {
        if (terminationDateDay === '' && terminationDateMonth === '' && terminationDateYear === '') {
            return false;
        }
        switch (field) {
            case 'day':
                if (Number(terminationDateDay) > 31 || Number(terminationDateDay) < 1) {
                    return true;
                } 
                break;
            case 'month':
                if (terminationDateMonth === '') {
                    return true;
                } 
                break;
            case 'year':
                if (Number(terminationDateYear) < 1900 || Number(terminationDateYear) > 3000) {
                    return true;
                } 
                break;
            default:
                return false;
                break;
        }
    };

    const handleTerminationDateDayChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateTerminationDateDay((event.target as HTMLInputElement).value);
    };

    const handleTerminationDateMonthChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateTerminationDateMonth((event.target as HTMLInputElement).value);
    };

    const handleTerminationDateYearChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateTerminationDateYear((event.target as HTMLInputElement).value);
    };

    const handleReimbursementTierApprovedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateReimbursementTierApproved((event.target as HTMLInputElement).value);
    };

    const handlePhysicianNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updatePhysicianName((event.target as HTMLInputElement).value);
    };

    const handlePhysicianLicenseChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value.length > 20) return;
        updatePhysicianLicense((event.target as HTMLInputElement).value.toUpperCase());
    };

    const handlePhysicianFSAChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updatePhysicianFSA((event.target as HTMLInputElement).value);
    };

    const handleAdminNotesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateAdminNotes((event.target as HTMLInputElement).value);
    };

    function getStatusText(ref: string) {
        let displayString = '';
        switch (ref) {
            case (DrugExceptionStatus[DrugExceptionStatus.UNDER_REVIEW]):
                displayString = 'Under Review';
                break;
            case (DrugExceptionStatus[DrugExceptionStatus.APPROVED]):
                displayString = 'Approved';
                break;
            case (DrugExceptionStatus[DrugExceptionStatus.INCOMPLETE]):
                displayString = 'Incomplete';
                break;
            case (DrugExceptionStatus[DrugExceptionStatus.NOT_APPROVED]):
                displayString = 'Not Approved';
                break;
            case (DrugExceptionStatus[DrugExceptionStatus.EXPIRED]):
                displayString = 'Not Approved';
                break;
            case (DrugExceptionStatus[DrugExceptionStatus.ASSESSED_APPROVED]):
                displayString = 'Assessed/Approved';
                break;
            case (DrugExceptionStatus[DrugExceptionStatus.ASSESSED_NOT_APPROVED]):
                displayString = 'Assessed/Not Approved';
                break;
            default:
                displayString = '';
                break;
        }
        return displayString;
    }

    const handleAssessorChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const newAssessorId = String(event.target.value);
        setAssessorId(newAssessorId);
    };

    const handleAssign = async () => {
        if (userId) {
            const token = userId.authToken;
            const id = userId.id;
            if (token && id) {
                const request = [
                    {
                        op: 'replace',
                        path: '/assessorId',
                        value: assessorId === '0' ? '' : assessorId
                    }
                ];

                const assessorAssignmentResponse = await drugExceptionsClient.api.patch(`/drugexceptions/${selectedDrugException.id}`, request, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }
        }
        history('/admin/dashboard');
    };

    const updateFieldsAvailable = () => {
        return !completed && !(handleEffectiveDateError('day')
            || handleEffectiveDateError('month')
            || handleEffectiveDateError('year')
            || handleTerminationDateError('day')
            || handleTerminationDateError('month')
            || handleTerminationDateError('year'));
    };

    const updateFields = async() => {
        try {
            if (userId) {
                const token = userId.authToken;
                const id = userId.id;
                if (token && id) {
                    const request = [
                        {
                            op: 'replace',
                            path: '/medicalCondition',
                            value: medicalCondition
                        },
                        {
                            op: 'replace',
                            path: '/DIN',
                            value: DIN
                        },
                        {
                            op: 'replace',
                            path: '/drugName',
                            value: drugName
                        },
                        {
                            op: 'replace',
                            path: '/effectiveDate',
                            value: effectiveDateDay === '' || effectiveDateMonth === '' || effectiveDateYear === '' ? null : new Date(Number(effectiveDateYear), Number(effectiveDateMonth), Number(effectiveDateDay))
                        },
                        {
                            op: 'replace',
                            path: '/terminationDate',
                            value: terminationDateDay === '' || terminationDateMonth === '' || terminationDateYear === '' ? null : new Date(Number(terminationDateYear), Number(terminationDateMonth), Number(terminationDateDay))
                        },
                        {
                            op: 'replace',
                            path: '/reimbursementTierApproved',
                            value: reimbursementTierApproved
                        },
                        {
                            op: 'replace',
                            path: '/physicianName',
                            value: physicianName
                        },
                        {
                            op: 'replace',
                            path: '/physicianLicense',
                            value: physicianLicense
                        },
                        {
                            op: 'replace',
                            path: '/physicianFSA',
                            value: physicianFSA
                        },
                        {
                            op: 'replace',
                            path: '/adminNotes',
                            value: adminNotes
                        },
                    ];

                    const updateFieldsResponse = await drugExceptionsClient.api.patch(`/drugexceptions/${selectedDrugException.id}`, request, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });

                    updateUpdatedMessage('Fields updated successfully!');
                    setTimeout(() => updateUpdatedMessage(''), 3000);
                }
            }
        } catch (error) {
            props.handleError(error);
        }

    };

    const handleSubmit = async () => {
        if (userId) {
            const token = userId.authToken;
            const id = userId.id;
            if (token && id) {
                const request = [
                    {
                        op: 'replace',
                        path: '/drugExceptionStatus',
                        value: status
                    }
                ];

                const assessorAssignmentResponse = await drugExceptionsClient.api.patch(`/drugexceptions/${selectedDrugException.id}`, request, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }
        }
        history('/admin/dashboard');
    };

    const handleReject = async () => {
        if (userId) {
            const token = userId.authToken;
            const id = userId.id;
            if (token && id) {
                const request = [
                    {
                        op: 'replace',
                        path: '/drugExceptionStatus',
                        value: DrugExceptionStatus[DrugExceptionStatus.INCOMPLETE]
                    }
                ];

                const assessorAssignmentResponse = await drugExceptionsClient.api.patch(`/drugexceptions/${selectedDrugException.id}`, request, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }
        }
        history('/admin/dashboard');
    };

    useEffect(() => {
        fetchData();
    }, []);

    const isAlphaNumeric = function(value: string){
        const regex = new RegExp(/^[a-zA-Z0-9]*$/);
        return regex.test(value);
    };

    const handlePhysicianNumberKeyDown = function(e: React.KeyboardEvent<HTMLInputElement>){
        if(!isAlphaNumeric(e.key)) {
            e.preventDefault();
        }         
    };


    return (
        <div className="admin-approve-container">
            <h1>CASE #{selectedDrugException.id}</h1>
            <div className='row'>
                <div className="column">
                    <div className='claimant-details'>
                        <div className='secondary-header'>Claimant Details</div>
                        <div className='name'>{selectedDrugException.claimant?.firstName} {selectedDrugException.claimant?.lastName} {isDependant ? <span>(DEPENDENT)</span> : <></>} </div>
                        <div className='detail-group'>
                            <div className='detail-label'>Gender:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.gender}</div>
                        </div>
                        <div className='detail-group'>
                            <div className='detail-label'>DOB:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.dateOfBirth ? FormatDateLocale(new Date(selectedDrugException.claimant?.dateOfBirth)): "--"}</div>
                        </div>
                        {
                            selectedDrugException.claimant?.identity
                            ? <div><div className='detail-group'>
                                <div className='detail-label'>Email:</div>
                                <div className='detail-info'>{selectedDrugException.claimant?.identity.email}</div>
                            </div>
                            <div className='detail-group'>
                                <div className='detail-label'>Phone:</div>
                                <div className='detail-info'>{selectedDrugException.claimant?.identity.phoneNumber}</div>
                            </div></div> : <></>
                        }
                    </div>
                    <div className='plan-member-details'>
                        <div className='secondary-header'>Plan Member Details</div>
                        <div className='name'>{selectedDrugException.claimant?.memberFirstName} {selectedDrugException.claimant?.memberLastName}</div>
                        <div className='detail-group'>
                            <div className='detail-label'>Policy #:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.policyNumber}</div>
                        </div>
                        <div className='detail-group'>
                            <div className='detail-label'>Certificate #:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.certificateNumber}</div>
                        </div>
                    </div>
                    {
                        accountHolder && selectedDrugException.claimant?.addedByUser
                        ? <div className='account-holder-details'>
                            <div className='secondary-header'>Account Holder Details</div>
                            <div className='name'>{accountHolder?.firstName} {accountHolder?.lastName}</div>
                            <div className='detail-group'>
                                <div className='detail-label'>Email:</div>
                                <div className='detail-info'>{selectedDrugException.claimant?.addedByUser.email}</div>
                            </div>
                            <div className='detail-group'>
                                <div className='detail-label'>Phone:</div>
                                <div className='detail-info'>{selectedDrugException.claimant?.addedByUser.phoneNumber}</div>
                            </div>
                          </div>
                        : <></>
                    }
                    <div className='secondary-header'>Drug Exception Details</div>
                    <div className="drug-exception-fields">
                        <TextField
                            id="medical-condition-input"
                            label="Medical Condition"
                            defaultValue={medicalCondition}
                            onChange={handleMedicalConditionChange}
                            variant="filled"
                            margin="normal"
                            disabled={completed}
                            inputProps={{
                                maxLength: 100
                            }}
                        />
                        <TextField
                            id="din-input"
                            label="DIN"
                            value={DIN}
                            onChange={handleDINChange}
                            variant="filled"
                            margin="normal"
                            type="number"
                            disabled={completed}
                        />
                        <TextField
                            id="drug-name-input"
                            label="Drug Name"
                            defaultValue={drugName}
                            onChange={handleDrugNameChange}
                            variant="filled"
                            margin="normal"
                            disabled={completed}
                            inputProps={{
                                maxLength: 100
                            }}
                        />
                        <div>Effective Date</div>
                        <div className="effective-date">
                            <TextField
                                id="effective-date-year-input"
                                label="Year"
                                defaultValue={effectiveDateYear}
                                onChange={handleEffectiveDateYearChange}
                                variant="filled"
                                margin="normal"
                                type="number"
                                error={handleEffectiveDateError('year')}
                                disabled={completed}
                            />
                            <FormControl disabled={completed} variant="filled" margin="normal" error={handleEffectiveDateError('month')}>
                                <InputLabel id="effective-date-month-input-label">Month</InputLabel>
                                <Select
                                    labelId="effective-date-month-input-label"
                                    id="effective-date-month-input"
                                    value={effectiveDateMonth}
                                    onChange={handleEffectiveDateMonthChange}
                                >
                                    <MenuItem value=""></MenuItem>
                                    <MenuItem value={0}>January</MenuItem>
                                    <MenuItem value={1}>February</MenuItem>
                                    <MenuItem value={2}>March</MenuItem>
                                    <MenuItem value={3}>April</MenuItem>
                                    <MenuItem value={4}>May</MenuItem>
                                    <MenuItem value={5}>June</MenuItem>
                                    <MenuItem value={6}>July</MenuItem>
                                    <MenuItem value={7}>August</MenuItem>
                                    <MenuItem value={8}>September</MenuItem>
                                    <MenuItem value={9}>October</MenuItem>
                                    <MenuItem value={10}>November</MenuItem>
                                    <MenuItem value={11}>December</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                id="effective-date-day-input"
                                label="Day"
                                defaultValue={effectiveDateDay}
                                onChange={handleEffectiveDateDayChange}
                                variant="filled"
                                margin="normal"
                                type="number"
                                error={handleEffectiveDateError('day')}
                                disabled={completed}
                            />
                        </div>
                        <div>Termination Date</div>
                        <div className="termination-date">
                            <TextField
                                id="termination-date-year-input"
                                label="Year"
                                defaultValue={terminationDateYear}
                                onChange={handleTerminationDateYearChange}
                                variant="filled"
                                margin="normal"
                                type="number"
                                error={handleTerminationDateError('year')}
                                disabled={completed}
                            />
                            <FormControl disabled={completed} variant="filled" margin="normal" error={handleTerminationDateError('month')}>
                                <InputLabel id="termination-date-month-input-label">Month</InputLabel>
                                <Select
                                    labelId="termination-date-month-input-label"
                                    id="termination-date-month-input"
                                    value={terminationDateMonth}
                                    onChange={handleTerminationDateMonthChange}
                                >
                                    <MenuItem value=""></MenuItem>
                                    <MenuItem value={0}>January</MenuItem>
                                    <MenuItem value={1}>February</MenuItem>
                                    <MenuItem value={2}>March</MenuItem>
                                    <MenuItem value={3}>April</MenuItem>
                                    <MenuItem value={4}>May</MenuItem>
                                    <MenuItem value={5}>June</MenuItem>
                                    <MenuItem value={6}>July</MenuItem>
                                    <MenuItem value={7}>August</MenuItem>
                                    <MenuItem value={8}>September</MenuItem>
                                    <MenuItem value={9}>October</MenuItem>
                                    <MenuItem value={10}>November</MenuItem>
                                    <MenuItem value={11}>December</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                id="termination-date-day-input"
                                label="Day"
                                defaultValue={terminationDateDay}
                                onChange={handleTerminationDateDayChange}
                                variant="filled"
                                margin="normal"
                                type="number"
                                error={handleTerminationDateError('day')}
                                disabled={completed}
                            />
                        </div>
                        <TextField
                            id="reimbursement-tier-approved-input"
                            label="Reimbursement Tier Approved"
                            defaultValue={reimbursementTierApproved}
                            onChange={handleReimbursementTierApprovedChange}
                            variant="filled"
                            margin="normal"
                            disabled={completed}
                            inputProps={{
                                maxLength: 50
                            }}
                        />
                        <TextField
                            id="physician-name-input"
                            label="Physician Name"
                            defaultValue={physicianName}
                            onChange={handlePhysicianNameChange}
                            variant="filled"
                            margin="normal"
                            disabled={completed}
                            inputProps={{
                                maxLength: 50
                            }}
                        />
                        <TextField
                            id="physician-license-input"
                            label="Physician License"
                            value={physicianLicense}
                            onChange={handlePhysicianLicenseChange}
                            onKeyDown={handlePhysicianNumberKeyDown}
                            variant="filled"
                            margin="normal"
                            type="text"
                            disabled={completed}
                        />
                        <TextField
                            id="physician-fsa-input"
                            label="Physician FSA"
                            defaultValue={physicianFSA}
                            onChange={handlePhysicianFSAChange}
                            variant="filled"
                            margin="normal"
                            disabled={completed}
                            inputProps={{
                                maxLength: 3
                            }}
                        />
                        <TextField
                            id="admin-notes-input"
                            label="Admin Notes"
                            defaultValue={adminNotes}
                            onChange={handleAdminNotesChange}
                            variant="filled"
                            margin="normal"
                            multiline
                            rows={4}
                            disabled={completed}
                            inputProps={{
                                maxLength: 500
                            }}
                        />
                        <div>
                            {
                                updateFieldsAvailable()
                                ? <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={updateFields}>
                                    <div className="mdc-button__ripple"></div>
                                    <span className="mdc-button__label">Update Fields</span>
                                  </button>
                                : <button disabled className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">
                                    <div className="mdc-button__ripple"></div>
                                    <span className="mdc-button__label">Update Fields</span>
                                  </button>
                            }
                        </div>
                        <p className="updated-message">{updatedMessage}</p>
                    </div>
                    <div className='assignment'>
                        <div className='secondary-header'>Assign Assessor</div>
                        <FormControl disabled={rejected || assigned} className='assessor-selector' variant="filled">
                            <InputLabel id="assessor-selector-label">Assigned assessor</InputLabel>
                            {loading ? (
                                <Select labelId="assessor-selector-label" value=''>
                                    <MenuItem value=''>Loading...</MenuItem>
                                </Select>
                            ) : (
                                    <Select labelId="assessor-selector-label" value={assessorId} onChange={handleAssessorChange}>
                                        <MenuItem value='0'>None</MenuItem>
                                        {assessors.map((a) => (
                                            <MenuItem key={a.id} value={a.id}>{a.firstName} {a.lastName}</MenuItem>
                                        ))}
                                    </Select>
                                )}
                        </FormControl>
                    </div>
                    {selectedDrugException.comment === ''
                        ? (
                            <></>
                        ) : (
                            <div className='assessor-decision'>
                                <div className='secondary-header'>Assessor Decision</div>
                                <div className='detail-group'>
                                    <div className='detail-label'>Status:</div>
                                    <div className='detail-info'>{getStatusText(selectedDrugException.drugExceptionStatus)}</div>
                                </div>
                                <div className='detail-group'>
                                    <div className='detail-label'>Comment:</div>
                                    <div className='detail-info'>{selectedDrugException.comment}</div>
                                </div>
                            </div>
                        )
                    }
                    {!underReview &&
                        <div className='submit-assessment'>
                            <div className='secondary-header'>Submit Assessment</div>
                        <RadioGroup
                                aria-label="gender"
                                name="gender1"
                                value={(status === DrugExceptionStatus[DrugExceptionStatus.APPROVED] || status === DrugExceptionStatus[DrugExceptionStatus.NOT_APPROVED]) ? status : selectedDrugException.drugExceptionStatus}
                                onChange={handleStatusChange}>
                                <FormControlLabel disabled={!assessed} className='status-radio' value={DrugExceptionStatus[DrugExceptionStatus.APPROVED]} control={<Radio />} label="Approved" />
                                <FormControlLabel disabled={!assessed} className='status-radio' value={DrugExceptionStatus[DrugExceptionStatus.NOT_APPROVED]} control={<Radio />} label="Not Approved" />
                            </RadioGroup>
                        </div>
                    }
                    <button disabled={(underReview && assigned) || completed || assessorId == '0'} className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={underReview ? handleAssign : handleSubmit}>
                        <div className="mdc-button__ripple"></div>
                        <span className="mdc-button__label">Submit</span>
                    </button>
                    {!assessed &&
                        <button disabled={rejected || assigned} className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={handleReject} >
                            <div className="mdc-button__ripple"></div>
                            <span className="mdc-button__label">Reject</span>
                        </button>
                    }
                </div>
                <div className="column">
                    <div className='secondary-header'>Submitted Form</div>
                    {documents.map(document => {
                        const documentUrl = document.url;

                        return document.file.type === 'image/jpeg' ? (
                            <img src={documentUrl} key={documentUrl} />
                        ) : (
                                <a href={documentUrl} key={documentUrl} download>Open pdf form</a>
                            );
                    })}
                </div>
            </div>
        </div>
    );

}